import type {
  GetWatchlistParams,
  WatchlistFilterOptions,
  WatchlistPageResponse,
} from "@/types/backtest"
import client from "./client"

export interface WatchlistCode {
  stockCode: string
  source: string
}

export async function getWatchlist(params: GetWatchlistParams = {}): Promise<WatchlistPageResponse> {
  const { data } = await client.get<WatchlistPageResponse>("/api/watchlist", { params })
  return data
}

export async function getWatchlistFilterOptions(): Promise<WatchlistFilterOptions> {
  const { data } = await client.get<WatchlistFilterOptions>("/api/watchlist/filters")
  return data
}

export async function updateWatchlistMemo(params: {
  stockCode: string
  searchedDate: string
  conditionName: string
  memo: string
}): Promise<void> {
  await client.put("/api/watchlist/memo", params)
}

export async function getWatchlistCodes(): Promise<WatchlistCode[]> {
  const { data } = await client.get<WatchlistCode[]>("/api/watchlist/codes")
  return data
}

export async function addManualWatchlist(stockCode: string): Promise<void> {
  await client.post("/api/watchlist/manual", { stockCode })
}

export async function deleteManualWatchlist(stockCode: string): Promise<void> {
  await client.delete(`/api/watchlist/manual/${stockCode}`)
}
